<template>
  <vs-row>
    <div>
      Ballstar has scorekeepers across the country ready to score your
      basketball games. If your games have already been played and you have
      video recordings, you can submit the games to us and we will score them.
    </div>
    <vs-divider />
    <vs-row>
      <vs-col
        >How Many Games did you need scored?
        <vs-input-number v-model="gamesToScore" min="0"></vs-input-number>
      </vs-col>
    </vs-row>
    <vs-row>
      <div>
        <vs-textarea
          name="description"
          icon-no-border
          icon="icon icon-user"
          icon-pack="feather"
          label="Details about Games"
          class="w-full"
          width="350px !important"
          v-model="description"
        />
      </div>
    </vs-row>
    <vs-row>
      <vs-col vs-w="6" vs-xs="12">
        <p>League Start:</p>
        <DatePicker :config="dateRangeConfig" v-model="leagueStart" />
      </vs-col>
    </vs-row>
    <vs-row>
      <div style="margin: 10px 0 0">
        <vs-button
          @click="
            $emit('scoreMyLeague', {
              startDate: leagueStart,
              games: gamesToScore,
              description
            })
          "
        >
          Submit Request
        </vs-button>
      </div>
    </vs-row>
  </vs-row>
</template>
<script>
import dateRangeConfig from "@/constants/date/dateRangeConfig";
import DatePicker from "vue-flatpickr-component";
export default {
  name: "ScoreMyLeague",
  components: {
    DatePicker
  },
  data: () => ({
    dateRangeConfig,
    leagueStart: null,
    gamesToScore: 1,
    description: ""
  }),
  methods: {}
};
</script>
